import { formatFrameTime } from '../format.js';
import { type PlayerController } from '../player/controller.js';
import { cursor, frames } from '../state/store.js';

type Props = {
  player: PlayerController;
};

export const Timeline = ({ player }: Props) => {
  const list = frames.value;
  const max = Math.max(0, list.length - 1);
  const current = list[cursor.value];
  const first = list[0];
  const last = list.at(-1);
  return (
    <div class="timeline">
      <input
        class="timeline__slider"
        type="range"
        min={0}
        max={max}
        step={1}
        value={cursor.value}
        disabled={list.length === 0}
        aria-label="Posición temporal"
        aria-valuetext={current === undefined ? '' : formatFrameTime(current.ts)}
        onInput={event => {
          player.pause();
          player.seek(Number(event.currentTarget.value));
        }}
      />
      <div class="timeline__ends">
        <span>{first === undefined ? '' : formatFrameTime(first.ts)}</span>
        <span>{current === undefined ? '' : `${cursor.value + 1}/${list.length}`}</span>
        <span>{last === undefined ? '' : formatFrameTime(last.ts)}</span>
      </div>
    </div>
  );
};
